import { badWords, disallowHtml, required } from '@seek/validators-js';
import { Heading, Stack, TextField } from 'braid-design-system';
import React from 'react';

import { withoutHighlight } from 'src/utils';
import { abnLength, numerical } from 'src/utils/validators';

import { useField } from '../../utils';
import PhoneNumberDetails from '../PhoneNumber/PhoneNumber';

const BusinessDetails = () => {
  const businessName = withoutHighlight(
    useField({
      id: 'businessName',
      validators: [required, badWords, disallowHtml],
    }),
  );

  const abn = withoutHighlight(
    useField({
      id: 'abn',
      validators: [required, numerical, abnLength],
      validatorProps: {
        requiredLabel: undefined,
        length: 11,
      },
    }),
  );

  return (
    <Stack space="large">
      <Heading level="3">Please provide your business details</Heading>

      <Stack space="large">
        <TextField
          id="businessName"
          type="text"
          label="Business name"
          onChange={businessName.onChange}
          value={businessName.value ? businessName.value : ''}
          tone={businessName.valid ? 'neutral' : 'critical'}
          message={!businessName.valid && businessName.errorMessage}
        />
        <TextField
          id="abn"
          type="text"
          label="Australian Business Number (ABN)"
          onChange={abn.onChange}
          value={abn.value ? abn.value : ''}
          tone={abn.valid ? 'neutral' : 'critical'}
          message={!abn.valid && abn.errorMessage}
        />
        <PhoneNumberDetails />
      </Stack>
    </Stack>
  );
};

export default BusinessDetails;
